import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber
  } from "../../../commonFunctions";
  
  const printoptions = {
    label: "Print Options",
    starting: true,
    url: "printoptions",
    pageLabel: "Print Options",
    pageType: "history",
    form: [
        {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print OD with Interest",
            name: "printodwithinterest",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Address",
            name: "printaddress",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Health",
            name: "printhealth",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Marathi Name",
            name: "printmarathiname",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print CIN",
            name: "printcin",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Loan Action",
            name: "printloanaction",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Guarantor",
            name: "printguarantor",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print NPA Status",
            name: "printnpastatus",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Reference Director",
            name: "printrefdirector",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Guarantor Below Name",
            name: "belowname",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print OD Date",
            name: "printoddate",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Inst-Amt",
            name: "printinstamt",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Detail Balance",
            name: "detailbalnce",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Interest Rate",
            name: "printinterestrate",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Security",
            name: "printsecurity",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Industry Type",
            name: "printindustrytype",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Last Req Balance",
            name: "printlastbalance",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Priority",
            name: "printpriority",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Occupation",
            name: "printoccupation",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print First Inst-Date",
            name: "printfirstinstdate",
            description: ""
          },
          {
            inputType: "checkbox",
            isRequired: true,
            default: "false",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Print Purpose",
            name: "printpurpose",
            description: ""
          },
    ]
}
export default printoptions
